// src/components/GallerySection/GallerySection.jsx

import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
// Videolar için Swiper eklentisini kullanacağız
import Video from "yet-another-react-lightbox/plugins/video";
// Thumbnail eklentisi de faydalı olabilir
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import PhotoAlbum from "react-photo-album";

import { FaPlay } from "react-icons/fa"; // Video ikonunu göstermek için
import "./GallerySection.scss";

// Galeri verileri - Lokalden alınan görseller ve videolar
// NOT: Video path'lerini ve poster (önizleme) görsellerini kendi projenize göre güncelleyin.
// Eğer YouTube videosu kullanacaksanız "type: 'youtube'" ve "src: 'https://youtu.be/...' " şeklinde düzenleyebilirsiniz.
const galleryData = [
  {
    id: 1,
    type: "image",
    src: "/gallery/gal-img1.jpeg", // Görsel yolu
    alt: "Kliniğimizden bir görüntü",
  },
  {
    id: 2,
    type: "video",
    src: "/gallery/gal-vid1.mp4", // Video yolu
    poster: "/gallery/vid1-tmb.png", // Video önizleme görseli (ÇOK ÖNEMLİ!)
    alt: "Kliniğimizde bir operasyon",
  },
  {
    id: 3,
    type: "image",
    src: "/gallery/gal-img2.jpeg",
    alt: "Kliniğimizin iç mekanından",
  },
  {
    id: 4,
    type: "video",
    src: "/gallery/gal-vid2.mp4",
    poster: "/gallery/vid2-tmb.png",
    alt: "Kliniğimizde hayvan dostlarımız",
  },
  {
    id: 5,
    type: "image",
    src: "/gallery/gal-img3.jpeg",
    alt: "Ekibimiz iş başında",
  },
  {
    id: 6,
    type: "video",
    src: "/gallery/gal-vid3.mp4",
    poster: "/gallery/vid3-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 7,
    type: "video",
    src: "/gallery/gal-vid4.mp4",
    poster: "/gallery/vid4-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 8,
    type: "video",
    src: "/gallery/gal-vid5.mp4",
    poster: "/gallery/vid5-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 9,
    type: "video",
    src: "/gallery/gal-vid6.mp4",
    poster: "/gallery/vid6-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 10,
    type: "video",
    src: "/gallery/gal-vid7.mp4",
    poster: "/gallery/vid7-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 11,
    type: "video",
    src: "/gallery/gal-vid8.mp4",
    poster: "/gallery/vid8-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 12,
    type: "video",
    src: "/gallery/gal-vid9.mp4",
    poster: "/gallery/vid9-tmb.png",
    alt: "Danışma bölümü",
  },
  {
    id: 13,
    type: "video",
    src: "/gallery/gal-vid10.mp4",
    poster: "/gallery/vid10-tmb.png",
    alt: "Danışma bölümü",
  },
];

const GallerySection = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(-1); // Hangi elemanın açılacağını belirler

  // Lightbox'ın beklediği formatta slaytları hazırla
  const slides = galleryData.map((item) => {
    if (item.type === "video") {
      return {
        type: "video",
        sources: [
          {
            src: item.src,
            type: "video/mp4",
          },
        ],
        poster: item.poster, // Video posteri
        alt: item.alt,
      };
    } else {
      return {
        src: item.src,
        alt: item.alt,
      };
    }
  });

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="gallery-grid">
          {galleryData.map((item, idx) => (
            <div
              key={item.id}
              className="gallery-item"
              onClick={() => {
                setIndex(idx);
                setOpen(true);
              }}
            >
              <img
                src={item.type === "video" ? item.poster : item.src}
                alt={item.alt}
                className="gallery-thumbnail"
              />
              {item.type === "video" && (
                <div className="video-overlay">
                  <FaPlay className="play-icon" />
                </div>
              )}
            </div>
          ))}
        </div>

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={index}
          plugins={[Video, Thumbnails]} // Video ve Thumbnail eklentilerini ekle
          // Thumbnail ayarları (isteğe bağlı)
          thumbnails={{
            position: "bottom",
            width: 120,
            height: 80,
            border: 1,
            borderRadius: 4,
            padding: 8,
          }}
          // Diğer ayarlar...
        />
      </div>
    </section>
  );
};

export default GallerySection;
